import { render, staticRenderFns } from "./superBros.vue?vue&type=template&id=11df05ac"
import script from "./superBros.vue?vue&type=script&lang=js"
export * from "./superBros.vue?vue&type=script&lang=js"
import style0 from "./superBros.vue?vue&type=style&index=0&id=11df05ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports